import colors from "assets/theme/base/colors";

export class SalesSummaryModel {
  constructor(company, color) {
    this.company = company;
    this.quarterSales1 = 0;
    this.quarterSales2 = 0;
    this.quarterSales3 = 0;
    this.quarterSales4 = 0;
    this.color = color != null ? color : "dark";
  }

  // Getter
  get total() {
    let total = this.quarterSales1 + this.quarterSales2 + this.quarterSales3 + this.quarterSales4;
    return total.toFixed(2);
  }
}

function getSalesData(data, quartersId) {
  // returns a List of SalesSummaryModel
  // returns list<SalesSummaryModel>

  const quarter1 = quartersId[0];
  const quarter2 = quartersId[1];
  const quarter3 = quartersId[2];
  const quarter4 = quartersId[3];

  let companies = [];
  let result = [];
  var color_list = Object.keys(colors.gradients);

  // get all companies
  data.forEach((elem) => {
    if (!companies.includes(elem.companyName)) {
      companies.push(elem.companyName);
    }
  });

  while (color_list.length <= companies.length) {
    color_list.push.apply(color_list, Object.keys(colors.gradients));
  }

  // build SalesSummary per company
  companies.forEach((company, index) => {
    var temp_company = new SalesSummaryModel(company, color_list[index]);

    data.forEach((row) => {
      if (company === row.companyName) {
        if (row.quarterId === quarter1) {
          temp_company.quarterSales1 = row.sale;
        } else if (row.quarterId === quarter2) {
          temp_company.quarterSales2 = row.sale;
        } else if (row.quarterId === quarter3) {
          temp_company.quarterSales3 = row.sale;
        } else if (row.quarterId === quarter4) {
          temp_company.quarterSales4 = row.sale;
        }
      }
    });

    result.push(temp_company);
  });
  // order list
  result.sort((a, b) => b.total - a.total);
  return result;
}

export default getSalesData;
